import { useRef, useEffect } from 'react';

export function useTwoTimestamps(key?: string) {
  const now = Date.now();
  const timestamp1 = useRef(now);
  const timestamp2 = useRef(now);

  useEffect(() => {
    timestamp1.current = Date.now();
  }, [key]);

  return {
    timestamp1,
    timestamp2,
    setTimestamp2: () => (timestamp2.current = timestamp1.current),
  };
}
